// If label contains email, format it as email a-tag
export default function formatEmailAsHtml(label: string) {
    const regex = new RegExp('([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+[a-zA-Z0-9_-]+)', 'ig');
    const rawTextString = label;

    const formattedTextString = rawTextString.replace(regex, '<a class="underline hover:no-underline focus:no-underline" href="mailto:$1">$1</a>');

    return formattedTextString;
}
